import MUIDataTable from 'mui-datatables';
import React, { Component } from 'react'
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
// 
import { currentTenant, userid } from '../../Common/Credentials.js';
import { spin } from '../../Common/NewLoader.jsx';
import { appmasterid } from '../../Common/Permissions.js';
import CustomToolbar from '../../CommonComponents/CustomToolbar.js';
import Header from '../../Component/Header.js';
import Menu from '../../Component/Menu.js';
import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material";
import HSNServices from './HSNServices.js';
import hsn from '../../Excel Templets/HSN.xlsx';
import * as XLSX from 'xlsx';
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';


const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, 'solid', '#ece6e6']],
      },
      body:
      {
        border: [[1, 'solid', '#ece6e6']],
      },
    },
  },
});


class HSNTable extends Component {


  constructor(props) {
    super(props)

    this.state = {
      message: '',
      hsnlists: [],
      hsnexcellist: [],
      loading: false,
      showadd: false,

    }

  }



  downloadExcel = () => {
    var link = document.createElement("a");
    link.href = hsn
    console.log(link.href)
    link.download = 'HSN';

    document.body.appendChild(link);

    link.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(link);
    }, 200);
  }

  readExcel = (file) => {

    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file)
      console.log(file)
      fileReader.onload = (e) => {
        console.log(e, e.target.result)
        const bufferArray = e.target.result;
        console.log(bufferArray)
        const wb = XLSX.read(bufferArray, { type: 'buffer' });
        console.log(wb)
        const wsname = wb.SheetNames[0];
        console.log(wsname)
        const ws = wb.Sheets[wsname];
        console.log(ws)
        const data = XLSX.utils.sheet_to_json(ws);
        console.log(data)
        resolve(data);
      }
      fileReader.onerror = error => {
        reject(error);
      }
    })
    promise.then((d) => {
      console.log(d)
      this.setState({ hsnexcellist: d })
    })
  }

  async refreshHSN() {

    // console.log(hsn)
    // var link = document.createElement("a");
    // link.href = hsn
    // console.log(link.href)

    fetch('../../Excel Templets/HSN.xlsx')
      .then((r) => r.blob())
      .then(blob => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
        console.log(blob)
      }))


    // const f = await (await fetch(link.href.toString())).arrayBuffer();
    // const wb = read(f); // parse the array buffer
    // const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
    // const data = utils.sheet_to_json(ws); // generate objects
    // setPres(data);
    // console.log(data)

    HSNServices.getHSNs(currentTenant)
      .then(
        response => {
          this.setState({ hsnlists: response.data })
          this.setState({ loading: false })
        }
      )
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })
  }

  uploadHSN = () => {
    if (this.state.hsnexcellist.length !== 0) {
      this.setState({ loader: true })
      let uploadbrand = {
        names: this.state.hsnexcellist,
        tenantid: currentTenant
      }
      HSNServices.UploadHSN(uploadbrand).then(() =>
        this.setState({ showadd: false }))
        .catch((e) => {
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
          this.setState({ message: e.response.data.message, loader: false })
        })
    }
  }

  componentDidMount() {

    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }

    //   UserService.UserPermissions(userid).then(response=>this.setState({up:response.data}))

    this.setState({ loading: true })

    this.refreshHSN();

  }

  render() {

    const columns = [
      { name: "id", label: "Id", options: { filter: false, sort: true, display: false } },
      { name: "hsn", label: "HSN", options: { filter: true, sort: true, } },
    ];
    const options = {
      filterType: 'checkbox',
      selectableRows: "none",
      customToolbar: () => {
        return (<>
          {appmasterid === '2' || appmasterid === '3' ?
            <span as="button" className="float-right btn btn-sm m-0 p-0" onClick={() => this.setState({ showadd: true })}>
              <CustomToolbar />
            </span>
            : ''
          }
        </>
        );
      }
    }
    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
        <div className='UI-container'>
        <div className={`UI-header`}>
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"HSN",path:null}]}/>
        </div>
                    <div className="UI-form-card">
                      <div>{this.state.loading === true ? <div className="text-center"> {spin}</div> :
                        <>
                          {this.state.showadd ?
                            <div className="form-row mb-3">
                              <fieldset className="form-group col-md-12">
                                <label className="text-red">Note: The Excel Sheet must contain only one column with name 'HSN', accepts only ".xlsx, .xls, .csv"</label>
                              </fieldset>
                              <fieldset className="mb-2">
                                <label>Download Excel format &nbsp;&nbsp;&nbsp;</label>
                                <button className="UI-btn UI-btn-primary" type='buton' data-tip data-for="pdf" onClick={this.downloadExcel}><i class="fa fa-download" aria-hidden="true"></i>
                                  &nbsp;Download</button>
                              </fieldset>
                              <fieldset className="form-group col-md-12"></fieldset>

                              <label>Upload here </label>

                              <fieldset className="form-group col-md-4 tw-ml-2">
                                <label htmlFor="btn-upload">
                                  <input
                                    className="btn-choose "
                                    id="btn-upload"
                                    name="btn-upload"
                                    type="file"
                                    onChange={e => {
                                      if (e.target.files[0] !== undefined) {
                                        const file = e.target.files[0];
                                        this.readExcel(file)
                                      }
                                    }}
                                    accept=".xlsx, .xls, .csv"
                                  />
                                </label>
                              </fieldset>
                              <fieldset className="form-group col-md-12">
                                <table>
                                  <tbody>

                                    {this.state.hsnexcellist.length === 0 ? '' : <label>HSN({this.state.hsnexcellist.length}):&nbsp;</label>}
                                    {this.state.hsnexcellist.map((e, i) =>
                                      <tr key={i}>
                                        <td className='text-start'>{i + 1}</td>
                                        <td className='text-start'>{e.hsn} </td>
                                        <td className='text-start'> - {e.description}</td>
                                      </tr>
                                    )}

                                  </tbody>
                                </table>
                              </fieldset>


                              {this.state.loader === true ? <button className="UI-btn UI-btn-primary" disabled><Spinner animation="border" size="sm" />&nbsp;{"Saving"}</button> : <span as='buton' className="UI-btn UI-btn-primary" onClick={this.uploadHSN}>Save</span>}
                              <span as="button" className="UI-btn UI-btn-outline ml-1" onClick={() => this.setState({ showadd: false })} > Cancel</span>

                            </div>
                            :
                            <ThemeProvider theme={theme}>
                              <MUIDataTable
                                className="table-sm"
                                title={"HSN"}
                                data={this.state.hsnlists}
                                columns={columns}
                                options={options}
                              />
                            </ThemeProvider>
                          }
                        </>
                      }</div>
                    </div>
          </div>
        </div>
      </div>

    )

  }

}
export default withRouter(HSNTable)